import React, {useContext, useEffect, useState} from "react";
import './MainPage.css'
import {Whatsapp, GearWide, Trash3, BalloonHeart, PersonCircle, StarFill, Shop, Diagram3} from "react-bootstrap-icons";
import HeadNavigation from "../../Components/HeadNavigation/HeadNavigation";
import {FeatureCard} from "../../Components/FeatureCard/FeatureCard";
import {Api} from "../../RequestsProvider/RequestProvider";
import {Context} from "../../ContextProvider/Context";
import {Config} from "../SettingsView/SettingsView";
import {SettingKey} from "../SettingsView/SettingKeyDescription";


interface InstanceStats {
    id: number,
    instanceName: string,
    createdAt: string,
    cpuUtilization: number,
    memoryUtilization: number
}

interface Props {
    apiKey: string
}

export const MainPage = ({apiKey}: Props) => {

    const [settings, setSettings] = useState<Config[]>()
    const [isAdminUser, setIsAdmin] = useState<boolean>(false)


    const context = useContext(Context)
    const request = useContext(Api)
    const {getSettings, isAdmin} = request!
    const {setContentLoading} = context!

    const fetchSettings = () => {
        getSettings().then((resp) => {
            setSettings(resp.message)
            setTimeout(() => setContentLoading(false), 600)
        })
    }

    useEffect(() => {
        isAdmin().then(res=>{
            if(res.message){
                setIsAdmin(true)
            }
        })
        setTimeout(() => fetchSettings(), 500)
    }, [])
    return (
        <>
            <HeadNavigation path={[{path: null, pathName: "Startseite"}]}/>
            <div className="container">
                <div className="row mt-4">
                    <div className="col-12 col-lg-4">
                        <FeatureCard description={"Füge Personen und Geburtstage hinzu"} icon={PersonCircle}
                                     name={"Personen"}
                                     path={"/personen"} isLoading={false}/>
                    </div>
                    <div className="col-12 col-lg-4">
                        <FeatureCard description={"Füge Müllerinnerungen hinzu"} icon={Trash3} name={"Müll"}
                                     path={"/muell"} isLoading={!settings} disabled={!settings?.find(setting => setting.setting_key === SettingKey.enableDailyGarbageChecker)?.setting_value}/>
                    </div>
                    <div className="col-12 col-lg-4">
                        {settings ?
                            <FeatureCard description={"wöchentliche Angebote aus dem Supermarkt"} icon={Shop}
                                         name={"Angebote"}
                                         path={"/angebote"}
                                         isLoading={false}
                                         disabled={!settings?.find(setting => setting.setting_key === SettingKey.getShoppingOffer)?.setting_value}/> :
                            <FeatureCard description={"wöchentliche Angebote aus dem Supermarkt"} icon={Shop}
                                         name={"Angebote"}
                                         path={"/"}
                                         isLoading={true}
                                         disabled/>
                        }
                    </div>
                    <div className="col-12 col-lg-4">
                        <FeatureCard description={"Upgrade deinen Account auf die nächste Stufe"} icon={StarFill}
                                     name={"Account Stufen"} path={"/tierList"} isLoading={false}/>
                    </div>
                    <div className="col-12 col-lg-4">
                        <FeatureCard description={"Verwalte die Einstellungen des WhatsApp Bots"} icon={GearWide}
                                     name={"Einstellungen"} path={"/einstellungen"} isLoading={false}/>
                    </div>
                    {isAdminUser ? <div className="col-12 col-lg-4">
                        <FeatureCard description={"Dashboard"} icon={Diagram3}
                                     name={"Admin"} path={"/admin"} isLoading={false}/>
                    </div> : null}
                </div>
            </div>
        </>
    )
}